import styled from "styled-components"
import ReactJWPlayer from "react-jw-player"

import { when, maxWidth } from "utils"

import SectionHeading from "components/section-heading"
import TextBlock from "components/text-block"

export const Container = styled.section`
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "block")};
  background-color: ${(props) => props.theme.component.background};
  margin: ${(props) =>
    props.isGrid && props.fullHeight && !props.isVideoCard
      ? "2rem 0"
      : props.isGrid && !props.fullHeight && !props.isVideoCard
      ? "0 0 0.6rem 0"
      : "0"};
  ${(props) => props.isGrid && props.fullHeight && !props.isVideoCard && "height:  45rem"};
  a {
    height: ${(props) =>
      props.isGrid && props.fullHeight && !props.isVideoCard ? "100%" : "auto"};
  }
  ${({ fillContainer }) =>
    fillContainer &&
    `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0;
  `};

  ${({ fillContainer, fullWidth, size }) => {
    if (fillContainer || fullWidth) return ""
    if (size === "Small") return "padding: 0 37.5%;"
    if (size === "Medium") return "padding: 0 25%;"
    if (size === "Large") return "padding: 0 12.5%;"
    return ""
  }}

  ${maxWidth.desktop`
    display: flex;
    flex-direction: column;

    ${({ fillContainer, fullWidth }) =>
      !fillContainer &&
      !fullWidth &&
      `
      padding: 0 1rem;
    `}
  `}

  ${(props) =>
    props.theme.component.isNested &&
    `
    padding: 0;
  `}


  ${when("isHomePage")`
    border-radius: 1rem;
  `}
  overflow: hidden;
`

export const JWPlayer = styled(ReactJWPlayer)`
  position: relative;
  width: 100%;
  height: ${({ fillContainer }) => (fillContainer ? "100%" : "auto")};
  padding-bottom: ${({ fillContainer, aspect }) => (fillContainer ? "0" : `${aspect * 100}%`)};
  video {
    object-fit: ${({ fillContainer, isGrid }) =>
      ((isGrid || fillContainer) && "cover !important") || "contain"};
  }
  div.jwplayer,
  div.jw-error {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
  }
  div.jwplayer,
  div.jw-preview {
    ${({ fillContainer }) => fillContainer && "background-size: cover !important"};
  }

  div.jw-flag-floating > div:nth-child(2) {
    ${maxWidth.mobile`
      top: unset;
      bottom: 10rem;
      left: unset;
      max-width: 60% !important;
    `}
  }

  ${when("noControls")`
    div.jw-controls {
      display: none;
    }
  `}

  ${maxWidth.desktop`
    width: 100%;
    height: 100%;
  `}
`

export const Title = styled(SectionHeading)`
  margin-top: 1.8rem;
  padding: 0 1rem;

  h2 {
    margin-bottom: 1.8rem;
    padding-bottom: 0;
    border-bottom: 0;
    font-size: 1.625em;
    text-align: center;
  }
`

export const Description = styled(TextBlock)`
  padding: 0 1rem 1.8rem;
  font-size: 1.6rem;
  text-align: center;
`
